import { render, staticRenderFns } from "./starUser.vue?vue&type=template&id=72f3cdd4&scoped=true&"
import script from "./starUser.vue?vue&type=script&lang=js&"
export * from "./starUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f3cdd4",
  null
  
)

export default component.exports